import { initScrollReveal } from './utils.js';
import { initSiteNav } from './components/nav.js';

document.addEventListener('DOMContentLoaded', () => {
    initScrollReveal();
    initSiteNav();
});